import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import DropDown from '../ui/react-ui/dropdown';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { getStatsTerminals } from '../../api/statsAPI';
import { setStatsTerminalsForPie, setStatsTerminalsPieSelected } from '../../redux/stats-dashboard';
var t = i18n.getFixedT(null, 'stats-dashboard');
var StatsTerminalsPieChart = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$statsDas = _useSelector.statsDashboard,
      statsTerminalsForPie = _useSelector$statsDas.statsTerminalsForPie,
      dateTime = _useSelector$statsDas.dateTime,
      statsTerminalsPieSelected = _useSelector$statsDas.statsTerminalsPieSelected,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();
  var pieChart = useRef();
  var label1 = useRef();
  var label2 = useRef();

  var calChartTotalCountObj = function calChartTotalCountObj(key) {
    var obj = {
      totalCount: 0,
      totalEntryCount: 0,
      totalExitCount: 0
    };

    _.map(statsTerminalsForPie, function (el) {
      obj.totalCount += Number(el.totalCount);
      obj.totalEntryCount += Number(el.entryCount);
      obj.totalExitCount += Number(el.exitCount);
    });

    return key ? obj[key] : obj;
  };

  useLayoutEffect(function () {
    pieChart.current = am4core.create('statsTerminalChart', am4charts.PieChart);
    pieChart.current.innerRadius = am4core.percent(60);
    am4core.addLicense;
    pieChart.current.hiddenState.properties.opacity = 0; // this creates initial fade-in
    // let colorSet = new am4core.ColorSet()
    // Add and configure Series

    var pieSeries = pieChart.current.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "terminal";
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.labels.template.disabled = true; // pieSeries.colors = colorSet
    // Set up labels

    label1.current = pieChart.current.seriesContainer.createChild(am4core.Label);
    label1.current.text = t('lbl-total-count', {
      count: calChartTotalCountObj('totalCount')
    });
    label1.current.horizontalCenter = "middle";
    label1.current.fontSize = 20;
    label1.current.fontWeight = 500;
    label1.current.dy = -16;
    label2.current = pieChart.current.seriesContainer.createChild(am4core.Label);
    label2.current.text = t('lbl-entry-exit-count', {
      entryCount: calChartTotalCountObj('totalEntryCount'),
      exitCount: calChartTotalCountObj('totalExitCount')
    });
    label2.current.horizontalCenter = "middle";
    label2.current.fontSize = 14;
    label2.current.dy = 14; // Add a legend

    pieChart.current.legend = new am4charts.Legend();
    pieChart.current.legend.position = "right";
    pieChart.current.legend.scrollable = true;
    pieChart.current.legend.maxWidth = '100';
    pieChart.current.legend.fontSize = '12';
    pieChart.current.data = _.map(statsTerminalsForPie, function (el) {
      return {
        terminal: el.terminalName,
        value: el.totalCount
      };
    }); // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      pieChart.current.dispose();
    };
  }, [JSON.stringify(statsTerminalsForPie)]); // useEffect(() => {
  //     // update labels
  //     label1.current.text = t('lbl-total-count', {
  //         count: calChartTotalCountObj('totalCount')
  //     })
  //     label2.current.text = t('lbl-entry-exit-count', {
  //         entryCount: calChartTotalCountObj('totalEntryCount'),
  //         exitCount: calChartTotalCountObj('totalExitCount')
  //     })
  //     // update pie data
  //     pieChart.current.data = _.map(statsTerminalsForPie, el => ({
  //         terminal: el.terminalName,
  //         value: el.totalCount
  //     }))
  // }, [JSON.stringify(statsTerminalsForPie)])

  var handleChange = function handleChange(zoneId) {
    dispatch(setStatsTerminalsPieSelected(zoneId));
    getStatsTerminals(contextRoot, false, zoneId, dateTime).then(function (data) {
      dispatch(setStatsTerminalsForPie(_.isEmpty(data.content) ? 'noData' : data.content));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "chart-dropdown"
  }, /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals-center'),
    list: zonesList,
    value: statsTerminalsPieSelected,
    onChange: handleChange,
    width: "200px"
  })), statsTerminalsForPie === 'noData' ? /*#__PURE__*/React.createElement("div", {
    className: "stats-terminal-chart-nodata"
  }, t('lbl-no-data')) : /*#__PURE__*/React.createElement("div", {
    id: "statsTerminalChart"
  }));
});
export default StatsTerminalsPieChart;